import { render } from "./MinigameView.vue?vue&type=template&id=19420387"
import script from "./MinigameView.vue?vue&type=script&lang=js"
export * from "./MinigameView.vue?vue&type=script&lang=js"

import "./MinigameView.vue?vue&type=style&index=0&id=19420387&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__